import styled, { css } from 'styled-components';

export const Container = styled.div`
  ${({ theme }) => css`
    width: 100%;
    flex: 1;

    display: flex;
    align-items: center;
    justify-content: center;

    background-color: ${theme.palette.neutral[50]};

    padding: 2rem;

    main {
      flex: 1;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      row-gap: 2rem;

      > section {
        display: flex;
        align-items: center;
        flex-direction: column;
        row-gap: 0.5rem;

        h1 {
          text-align: center;
          color: ${theme.palette.text.main};
          font-size: ${theme.typography.sizes.title1};
        }

        p {
          text-align: center;
          color: ${theme.palette.text.light};
          font-size: ${theme.typography.sizes.body1};
          width: 60%;
        }

        ul {
          color: ${theme.palette.text.light};
          width: 60%;

          list-style: circle;
        }
      }

      footer {
        display: flex;
        flex-direction: column;
        justify-content: center;
        gap: 1rem;

        button {
          padding: 0 1.5rem;
        }
      }
    }
  `}
`;
